import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import {
  LOGIN,
  HOMEPAGE,
  PROFILE,
  BOUNAKIR,
  BOUNKIR_LINKS,
  SIGNUP,
  COMPLETE_SIGNUP,
  COMPLETE_QUESTIONS,
  ABOUT_ME_SENTENCE,
  SMS_VERIFICATION,
  DOUBLE_MATCH,
  SELECT_MOOD,
  CONVERSTAION,
  CHAT,
  ADVANCED_SEARCH,
  EDIT_PROFILE,
  UPDATE_LOOKING_FOR,
  UPDATE_BIRTHDATE,
  UPDATE_QUESTION_TAG,
  UPDATE_PERSONAL_STATUS,
  MY_PROFILE,
  SETTINGS,
  UPDATE_NICKNAME,
  UPDATE_MEMBER_LOCATION,
  UPDATE_EMAIL,
  UPDATE_PASSWORD,
  RESET_PASSWORD,
  EMAIL_VERIFIED,
  ONBORADING_SCREEN,
  VERIFY_PROFILE,
  SIGNUP_MENU,
  COMPLETED_PROFILE_PAGE,
  PREMIUM_MESSAGE,
  PREMIUM_PLAN_DETAILS,
  UPDATE_HEIGHT,
  BOUNAKIR_WATCH_ME,
  HOME_SEARCH_USER,
  SEARCH_MEMBERS_RESULTS,
  PAYMENT_SUCCESS,
  PAYMENT_FAILURE,
  TERMS_OF_USE,
  PRIVACY_POLICY,
} from "./Constants";
import Login from "../pages/Login/Login";
import Home from "../pages/Home";
import Bounakir from "../pages/Bounakir";
import Signup from "../pages/Signup";
import CompleteRegistretion from "../pages/Signup/CompleteRegistretion";
import Profile from "../pages/Profile";
import NotFound from "../pages/NotFound";
import PrivateRoute from "./ProtectedRoute";
import CompleteProfileQuestions from "../pages/Home/components/CompleteProfileQuestions";
import SmsVerification from "./../pages/SmsVerification/";
import { BounakirMessage } from "../pages/DoubleMatch";
import DoubleMatch from "./../pages/DoubleMatch/DoubleMatch";
import Mood from "./../pages/Mood/";
import Converstaion from "./../pages/Converstaion";
import ChatScreen from "./../pages/Chat/ChatScreen";
import AdvancedSearch from "../pages/AdvancedSearch/AdvancedSearch";
import PremiumBlock from "../components/premium/PremiumMessage";
import {
  EditProfile,
  UpdatePersonalStatusQuestion,
  UpdateLookingForQuestion,
  UpdateAboutMeSentence,
  UpdateBirthdate,
  UpdateQuestionTag,
  UpdateNickName,
  UpdateLocation,
  UpdateEmail,
  UpdatePassword,
  MyProfileContainer,
} from "../pages/MyProfile/index";
import Settings from "../pages/MyProfile/Settings";
import GetParameterPopups from "./../components/GetParamaterPopups";
import resetPassword from "../pages/AccountPages/ResetPasword";
import EmailVerified from "./../pages/AccountPages/EmailVerified";
import OnBoardingSlider from "../pages/OnboardingPage/OnBoardingSlider";
import ProfilePhotoVerify from "../pages/ProfileVerify/ProfilePhotoVerify";
import BounkirLinks from "./../pages/BounakirLinks/BounakirLinks";
import SignupMenu from "../pages/Signup/SignupMenu";
import CompletedProfilePage from "../components/CompletedProfilePage";
import PremiumPlanDetails from "../components/premium/PremiumPlanDetails";
import UpdateHeight from "../pages/MyProfile/components/UpdateHeight";
import BounakirWatchMeContainer from "../pages/Bounakir/components/BounakirWatchMe/BounakirWatchMeContainer";
import SearchUserByCriteria from "../pages/SearchUsers/components/SearchUserByCriteria";
import SearchMembersResultsView from "../pages/SearchMembersResults/components/SearchMembersResultsView";
import PaymentSuccess from "../pages/Payment/PaymentSuccess";
import PaymentFailure from "../pages/Payment/PaymentFailure";
import TermsOfUse from "../pages/TermsOfUse/TermsOfUse";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";

export const RouterConfig = () => {
  let location: any = useLocation();
  let background = location.state && location.state.background;

  return (
    <div>
      <Switch location={background || location}>
        {/* <Route exact path={HOMEPAGE} component={Home} />
                <Route exact path={PROFILE} component={Profile} /> */}
        <Route path={ONBORADING_SCREEN} component={OnBoardingSlider} />
        <Route path={LOGIN} component={Login} />
        <Route path={RESET_PASSWORD} component={resetPassword} />
        <Route path={EMAIL_VERIFIED} component={EmailVerified} />
        <Route path={SIGNUP} component={Signup} />
        <Route path={COMPLETE_SIGNUP} component={CompleteRegistretion} />
        <Route path={SIGNUP_MENU} component={SignupMenu} />
        <PrivateRoute path={HOMEPAGE} component={Home} />
        <Route path={PAYMENT_SUCCESS} component={PaymentSuccess} />
        <Route path={PAYMENT_FAILURE} component={PaymentFailure} />
        <PrivateRoute exact path={PROFILE} component={Profile} />
        <PrivateRoute exact path={EDIT_PROFILE} component={EditProfile} />
        {/* <PrivateRoute path={BOUNAKIR} component={Bounakir} /> */}
        <PrivateRoute
          path={BOUNAKIR_WATCH_ME}
          component={BounakirWatchMeContainer}
        />
        <PrivateRoute
          path={COMPLETE_QUESTIONS}
          component={CompleteProfileQuestions}
        />
        <PrivateRoute path={SMS_VERIFICATION} component={SmsVerification} />
        <PrivateRoute path={DOUBLE_MATCH} component={DoubleMatch} />
        <PrivateRoute path={SELECT_MOOD} component={Mood} />
        <PrivateRoute path={CONVERSTAION} component={Converstaion} />
        <PrivateRoute path={MY_PROFILE} component={MyProfileContainer} />
        <PrivateRoute path={CHAT} component={ChatScreen} />
        <PrivateRoute path={ADVANCED_SEARCH} component={AdvancedSearch} />
        <PrivateRoute
          path={UPDATE_LOOKING_FOR}
          component={UpdateLookingForQuestion}
        />
        <PrivateRoute
          path={ABOUT_ME_SENTENCE}
          component={UpdateAboutMeSentence}
        />
        <PrivateRoute path={UPDATE_BIRTHDATE} component={UpdateBirthdate} />
        <PrivateRoute
          path={UPDATE_QUESTION_TAG}
          component={UpdateQuestionTag}
        />
        <PrivateRoute
          path={UPDATE_PERSONAL_STATUS}
          component={UpdatePersonalStatusQuestion}
        />
        <PrivateRoute
          path={UPDATE_MEMBER_LOCATION}
          component={UpdateLocation}
        />
        <PrivateRoute path={UPDATE_HEIGHT} component={UpdateHeight} />
        <PrivateRoute path={UPDATE_NICKNAME} component={UpdateNickName} />
        <PrivateRoute path={UPDATE_EMAIL} component={UpdateEmail} />
        <PrivateRoute path={UPDATE_PASSWORD} component={UpdatePassword} />
        <PrivateRoute path={SETTINGS} component={Settings} />
        <PrivateRoute path={VERIFY_PROFILE} component={ProfilePhotoVerify} />
        <PrivateRoute path={BOUNKIR_LINKS} component={BounkirLinks} />
        <PrivateRoute
          path={COMPLETED_PROFILE_PAGE}
          component={CompletedProfilePage}
        />
        <PrivateRoute path={PREMIUM_MESSAGE} component={PremiumBlock} />
        <PrivateRoute
          path={PREMIUM_PLAN_DETAILS}
          component={PremiumPlanDetails}
        />

        <PrivateRoute
          path={HOME_SEARCH_USER}
          component={SearchUserByCriteria}
        />

        <PrivateRoute
          path={SEARCH_MEMBERS_RESULTS}
          component={SearchMembersResultsView}
        />

        <PrivateRoute path={TERMS_OF_USE} component={TermsOfUse} />
        <PrivateRoute path={PRIVACY_POLICY} component={PrivacyPolicy} />

        <Redirect from="/" exact to={HOMEPAGE} />
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
      <GetParameterPopups />
      {/* {background && <Route path="/profile/:id" children={<ProfileModalDemo />} />} */}
    </div>
  );
};
